import React from 'react';
import { ConversationUpdateModal } from '../../conversation-update-modal/conversation-update-modal';
import { ModalContentsList } from '../../modal-contents-list';
import { ConvervationModalVariant, ModalContentItemData } from '../../../types';
import { SVGS } from '../../../assets';

interface MoreActionsModalProps {
  open: boolean;
  onClose: () => void;
  customerName: string;
  onActionPress: (action: ConvervationModalVariant) => void;
}

export const MoreActionsModal: React.FC<MoreActionsModalProps> = ({
  open,
  onClose,
  customerName,
  onActionPress,
}) => {
  const options: ModalContentItemData[] = [
    {
      icon: <img src={SVGS.ChangeStatus} alt="change-status" />,
      title: 'Change Status',
      onPress: () => onActionPress('update-status'),
    },
  ];

  return (
    <ConversationUpdateModal
      open={open}
      onClose={onClose}
      header="More Actions"
      customerName={customerName}
    >
      <ModalContentsList data={options} showArrow={true} />
    </ConversationUpdateModal>
  );
};
